import React, { useState } from "react";
import { BuildProfile } from "./BuildProfile";
import { Questioner } from "./Questioner";
export const QuestionerMain = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNextStep = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };
  const handlePervStep = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };
  return (
    <div>
      {currentStep === 1 && <BuildProfile onNext={handleNextStep} />}
      {currentStep === 2 && <Questioner />}
    </div>
  );
};
